import React, { useEffect, useRef } from 'react';
import { useChatStore } from '../../stores/useChatStore';
import MessageBubble from './MessageBubble';
import './ChatWindow.css';

export default function ChatWindow() {
  const { messages, currentSessionId, error } = useChatStore();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  if (!currentSessionId) {
    return (
      <div className="chat-window chat-window-empty">
        <div className="chat-empty-card">
          <h3>Willkommen!</h3>
          <p>Starte links eine neue Unterhaltung, um mit einem KI-Modell zu chatten.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-window" ref={scrollRef}>
      <div className="chat-messages">
        {messages.length === 0 && (
          <div className="chat-empty-card">
            <p>Stelle eine Frage, um die Unterhaltung zu beginnen.</p>
          </div>
        )}
        {messages.map((m, i) => (
          <MessageBubble key={m._id || `tmp-${i}`} message={m} />
        ))}
        {error && <div className="chat-error">{error}</div>}
      </div>
    </div>
  );
}
